import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { StockItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Download } from '../Download';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Stock } from '../RowFor/Stock';
import { Size } from '../Size';

const StockItem = (props: StockItemProps) => {
    const { onCheckboxClick, isSelected, kind, thumbUrl, isFolder, isVirus, ext, name, size, onDownload, id, storage } = props;
    const windowWidth = useWindowWidth();

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Stock {...props} checkboxClassname={newStyles.check} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
                    <Pic kind={kind} thumbUrl={thumbUrl} isFolder={isFolder} isVirus={!!isVirus} ext={ext || ''} />

                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemName name={name} ext={ext || ''} id={id} />
                            {size && <Size size={size} />}
                            <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <>
                                    <ItemName name={name} ext={ext || ''} id={id} />
                                </>
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemName name={name} ext={ext || ''} id={id} />
                                    <span className={styles.responsiveDateWrapper}>
                                        <Size size={size} />
                                    </span>
                                </div>
                            )}
                            {windowWidth > BREAKPOINT_SM && <Size size={size} />}
                            <div className={styles.actionsWrapper}>
                                <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
                            </div>
                        </>
                    )}
                </>
            }
        />
    );
};

export default StockItem;
